export function getPathValue(value: object, path: string): any {
  if (!value || !path) {
    return value;
  }
  const pathArr = path.split('.');

  if (!pathArr.length) {
    return value;
  }

  let valueOfPath = value;

  if (!valueOfPath) {
    return value;
  }

  pathArr.forEach((p) => {
    valueOfPath = valueOfPath[p];
  });

  return valueOfPath;
}
